
const ChemotherapyContent = () => {
    return (
        <>
            <h4>
                Neoadjuvant Chemotherapy
            </h4>
            <p>
                Clinical trials research shows that neoadjuvant chemotherapy – chemotherapy treatment before surgery – allows some women to undergo breast conserving surgery (lumpectomy), rather than a full mastectomy
            </p>
        </>
    );
}

export default ChemotherapyContent;